import Objdict from "objdict"

export default class Player {
    static copy(alphaplayer) {
        if(alphaplayer == undefined) return undefined
        return {
            ...alphaplayer,
            // "score": alphaplayer.score,
            // "affiliation": alphaplayer.affiliation,
            // "perks": alphaplayer.perks && Object.values(alphaplayer.perks),
            "equipments": alphaplayer.equipments && {
                ...alphaplayer.equipments
            },
            "inventory": alphaplayer.inventory && {
                ...alphaplayer.inventory,
                "items": Objdict.map(alphaplayer.inventory.items, (item) => {
                    const copiedItem = {}
                    for(let key in item) {
                        if(item[key] != undefined) {
                            copiedItem[key] = item[key]
                        }
                    }
                    return copiedItem
                })
            },
            "units": Objdict.map(alphaplayer.units, (unit) => unit)
        }
    }
}
